module.exports = __webpack_public_path__ + "static/media/report.20c4cf31.svg";